var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pos"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),(this.$store.state.PosId == null)?_c('SetPOS'):_c('UserCardreader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }